import { render } from "./integrations.html?vue&type=template&id=67c1c972&external"
import script from "./Integrations.js?vue&type=script&lang=js&external"
export * from "./Integrations.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__